import { isPG } from '../../../../core/helpers/skinHelper';

export const ROULETTE_CHIPS_COLOR = [
  'skyblue',
  'pink_1k',
  'purple_1k',
  'darkblue_1k',
  'lightblue_1k',
  'orange_1k',
  'green_1k',
  'red_1k',
  'purple1_10k',
  'yellow_100k',
];

export const marketType = {
  StraightUp_0: 0,
  StraightUp_1: 1,
  StraightUp_2: 2,
  StraightUp_3: 3,
  StraightUp_4: 4,
  StraightUp_5: 5,
  StraightUp_6: 6,
  StraightUp_7: 7,
  StraightUp_8: 8,
  StraightUp_9: 9,
  StraightUp_10: 10,
  StraightUp_11: 11,
  StraightUp_12: 12,
  StraightUp_13: 13,
  StraightUp_14: 14,
  StraightUp_15: 15,
  StraightUp_16: 16,
  StraightUp_17: 17,
  StraightUp_18: 18,
  StraightUp_19: 19,
  StraightUp_20: 20,
  StraightUp_21: 21,
  StraightUp_22: 22,
  StraightUp_23: 23,
  StraightUp_24: 24,
  StraightUp_25: 25,
  StraightUp_26: 26,
  StraightUp_27: 27,
  StraightUp_28: 28,
  StraightUp_29: 29,
  StraightUp_30: 30,
  StraightUp_31: 31,
  StraightUp_32: 32,
  StraightUp_33: 33,
  StraightUp_34: 34,
  StraightUp_35: 35,
  StraightUp_36: 36,
  Split_0_1: 37,
  Split_0_2: 38,
  Split_0_3: 39,
  Split_1_2: 40,
  Split_2_3: 41,
  Split_4_5: 42,
  Split_5_6: 43,
  Split_7_8: 44,
  Split_8_9: 45,
  Split_10_11: 46,
  Split_11_12: 47,
  Split_13_14: 48,
  Split_14_15: 49,
  Split_16_17: 50,
  Split_17_18: 51,
  Split_19_20: 52,
  Split_20_21: 53,
  Split_22_23: 54,
  Split_23_24: 55,
  Split_25_26: 56,
  Split_26_27: 57,
  Split_28_29: 58,
  Split_29_30: 59,
  Split_31_32: 60,
  Split_32_33: 61,
  Split_34_35: 62,
  Split_35_36: 63,
  Split_1_4: 64,
  Split_4_7: 65,
  Split_7_10: 66,
  Split_10_13: 67,
  Split_13_16: 68,
  Split_16_19: 69,
  Split_19_22: 70,
  Split_22_25: 71,
  Split_25_28: 72,
  Split_28_31: 73,
  Split_31_34: 74,
  Split_2_5: 75,
  Split_5_8: 76,
  Split_8_11: 77,
  Split_11_14: 78,
  Split_14_17: 79,
  Split_17_20: 80,
  Split_20_23: 81,
  Split_23_26: 82,
  Split_26_29: 83,
  Split_29_32: 84,
  Split_32_35: 85,
  Split_3_6: 86,
  Split_6_9: 87,
  Split_9_12: 88,
  Split_12_15: 89,
  Split_15_18: 90,
  Split_18_21: 91,
  Split_21_24: 92,
  Split_24_27: 93,
  Split_27_30: 94,
  Split_30_33: 95,
  Split_33_36: 96,
  Street_0_1_2: 97,
  Street_0_2_3: 98,
  Street_1_2_3: 99,
  Street_4_5_6: 100,
  Street_7_8_9: 101,
  Street_10_11_12: 102,
  Street_13_14_15: 103,
  Street_16_17_18: 104,
  Street_19_20_21: 105,
  Street_22_23_24: 106,
  Street_25_26_27: 107,
  Street_28_29_30: 108,
  Street_31_32_33: 109,
  Street_34_35_36: 110,
  Corner_0_1_2_3: 111,
  Corner_1_2_4_5: 112,
  Corner_2_3_5_6: 113,
  Corner_4_5_7_8: 114,
  Corner_5_6_8_9: 115,
  Corner_7_8_10_11: 116,
  Corner_8_9_11_12: 117,
  Corner_10_11_13_14: 118,
  Corner_11_12_14_15: 119,
  Corner_13_14_16_17: 120,
  Corner_14_15_17_18: 121,
  Corner_16_17_19_20: 122,
  Corner_17_18_20_21: 123,
  Corner_19_20_22_23: 124,
  Corner_20_21_23_24: 125,
  Corner_22_23_25_26: 126,
  Corner_23_24_26_27: 127,
  Corner_25_26_28_29: 128,
  Corner_26_27_29_30: 129,
  Corner_28_29_31_32: 130,
  Corner_29_30_32_33: 131,
  Corner_31_32_34_35: 132,
  Corner_32_33_35_36: 133,
  SixLine_1_2_3_4_5_6: 134,
  SixLine_4_5_6_7_8_9: 135,
  SixLine_7_8_9_10_11_12: 136,
  SixLine_10_11_12_13_14_15: 137,
  SixLine_13_14_15_16_17_18: 138,
  SixLine_16_17_18_19_20_21: 139,
  SixLine_19_20_21_22_23_24: 140,
  SixLine_22_23_24_25_26_27: 141,
  SixLine_25_26_27_28_29_30: 142,
  SixLine_28_29_30_31_32_33: 143,
  SixLine_31_32_33_34_35_36: 144,
  Column_1: 145,
  Column_2: 146,
  Column_3: 147,
  Dozen_1: 148,
  Dozen_2: 149,
  Dozen_3: 150,
  Red: 151,
  Black: 152,
  Even: 153,
  Odd: 154,
  Numbers_1_18: 155,
  Numbers_19_36: 156,
  Tiers: 157,
  Orphelins: 158,
  Voisins: 159,
  Zero: 160,
};

export const INCLUDED_SPINS = [
  marketType.Tiers,
  marketType.Orphelins,
  marketType.Voisins,
  marketType.Zero,
];

export const CombinationTypes = {
  [marketType.Tiers]: [
    marketType.Split_5_8,
    marketType.Split_10_11,
    marketType.Split_13_16,
    marketType.Split_23_24,
    marketType.Split_27_30,
    marketType.Split_33_36,
  ],
  [marketType.Orphelins]: [
    marketType.StraightUp_1,
    marketType.Split_6_9,
    marketType.Split_14_17,
    marketType.Split_17_20,
    marketType.Split_31_34,
  ],
  [marketType.Voisins]: [
    marketType.Street_0_2_3,
    marketType.Split_4_7,
    marketType.Split_12_15,
    marketType.Split_18_21,
    marketType.Split_19_22,
    marketType.Split_32_35,
    marketType.Corner_25_26_28_29,
  ],
  [marketType.Zero]: [
    marketType.StraightUp_26,
    marketType.Split_0_3,
    marketType.Split_12_15,
    marketType.Split_32_35,
  ],
};

export const BetType = {
  Corner_0_1_2_3: 'Corner_0_1_2_3',
  Street_0_1_2: 'Street_0_1_2',
  Street_0_2_3: 'Street_0_2_3',
  StraightUp_0: 'StraightUp_0',
  Corner_2_3_5_6: 'Corner_2_3_5_6',
  Split_0_3: 'Split_0_3',
  Split_2_3: 'Split_2_3',
  StraightUp_3: 'StraightUp_3',
  Corner_5_6_8_9: 'Corner_5_6_8_9',
  Split_3_6: 'Split_3_6',
  Split_5_6: 'Split_5_6',
  StraightUp_6: 'StraightUp_6',
  Corner_8_9_11_12: 'Corner_8_9_11_12',
  Split_6_9: 'Split_6_9',
  Split_8_9: 'Split_8_9',
  StraightUp_9: 'StraightUp_9',
  Corner_11_12_14_15: 'Corner_11_12_14_15',
  Split_9_12: 'Split_9_12',
  Split_11_12: 'Split_11_12',
  StraightUp_12: 'StraightUp_12',
  Corner_14_15_17_18: 'Corner_14_15_17_18',
  Split_12_15: 'Split_12_15',
  Split_14_15: 'Split_14_15',
  StraightUp_15: 'StraightUp_15',
  Corner_17_18_20_21: 'Corner_17_18_20_21',
  Split_15_18: 'Split_15_18',
  Split_17_18: 'Split_17_18',
  StraightUp_18: 'StraightUp_18',
  Corner_20_21_23_24: 'Corner_20_21_23_24',
  Split_18_21: 'Split_18_21',
  Split_20_21: 'Split_20_21',
  StraightUp_21: 'StraightUp_21',
  Corner_23_24_26_27: 'Corner_23_24_26_27',
  Split_21_24: 'Split_21_24',
  Split_23_24: 'Split_23_24',
  StraightUp_24: 'StraightUp_24',
  Corner_26_27_29_30: 'Corner_26_27_29_30',
  Split_24_27: 'Split_24_27',
  Split_26_27: 'Split_26_27',
  StraightUp_27: 'StraightUp_27',
  Corner_29_30_32_33: 'Corner_29_30_32_33',
  Split_27_30: 'Split_27_30',
  Split_29_30: 'Split_29_30',
  StraightUp_30: 'StraightUp_30',
  Corner_32_33_35_36: 'Corner_32_33_35_36',
  Split_30_33: 'Split_30_33',
  Split_32_33: 'Split_32_33',
  StraightUp_33: 'StraightUp_33',
  Split_33_36: 'Split_33_36',
  Split_35_36: 'Split_35_36',
  StraightUp_36: 'StraightUp_36',
  Corner_1_2_4_5: 'Corner_1_2_4_5',
  Split_0_2: 'Split_0_2',
  Split_1_2: 'Split_1_2',
  StraightUp_2: 'StraightUp_2',
  Corner_4_5_7_8: 'Corner_4_5_7_8',
  Split_2_5: 'Split_2_5',
  Split_4_5: 'Split_4_5',
  StraightUp_5: 'StraightUp_5',
  Corner_7_8_10_11: 'Corner_7_8_10_11',
  Split_5_8: 'Split_5_8',
  Split_7_8: 'Split_7_8',
  StraightUp_8: 'StraightUp_8',
  Corner_10_11_13_14: 'Corner_10_11_13_14',
  Split_8_11: 'Split_8_11',
  Split_10_11: 'Split_10_11',
  StraightUp_11: 'StraightUp_11',
  Corner_13_14_16_17: 'Corner_13_14_16_17',
  Split_11_14: 'Split_11_14',
  Split_13_14: 'Split_13_14',
  StraightUp_14: 'StraightUp_14',
  Corner_16_17_19_20: 'Corner_16_17_19_20',
  Split_14_17: 'Split_14_17',
  Split_16_17: 'Split_16_17',
  StraightUp_17: 'StraightUp_17',
  Corner_19_20_22_23: 'Corner_19_20_22_23',
  Split_17_20: 'Split_17_20',
  Split_19_20: 'Split_19_20',
  StraightUp_20: 'StraightUp_20',
  Corner_22_23_25_26: 'Corner_22_23_25_26',
  Split_20_23: 'Split_20_23',
  Split_22_23: 'Split_22_23',
  StraightUp_23: 'StraightUp_23',
  Corner_25_26_28_29: 'Corner_25_26_28_29',
  Split_23_26: 'Split_23_26',
  Split_25_26: 'Split_25_26',
  StraightUp_26: 'StraightUp_26',
  Corner_28_29_31_32: 'Corner_28_29_31_32',
  Split_26_29: 'Split_26_29',
  Split_28_29: 'Split_28_29',
  StraightUp_29: 'StraightUp_29',
  Corner_31_32_34_35: 'Corner_31_32_34_35',
  Split_29_32: 'Split_29_32',
  Split_31_32: 'Split_31_32',
  StraightUp_32: 'StraightUp_32',
  Split_32_35: 'Split_32_35',
  Split_34_35: 'Split_34_35',
  StraightUp_35: 'StraightUp_35',
  SixLine_1_2_3_4_5_6: 'SixLine_1_2_3_4_5_6',
  Split_0_1: 'Split_0_1',
  Street_1_2_3: 'Street_1_2_3',
  StraightUp_1: 'StraightUp_1',
  SixLine_4_5_6_7_8_9: 'SixLine_4_5_6_7_8_9',
  Split_1_4: 'Split_1_4',
  Street_4_5_6: 'Street_4_5_6',
  StraightUp_4: 'StraightUp_4',
  SixLine_7_8_9_10_11_12: 'SixLine_7_8_9_10_11_12',
  Split_4_7: 'Split_4_7',
  Street_7_8_9: 'Street_7_8_9',
  StraightUp_7: 'StraightUp_7',
  SixLine_10_11_12_13_14_15: 'SixLine_10_11_12_13_14_15',
  Split_7_10: 'Split_7_10',
  Street_10_11_12: 'Street_10_11_12',
  StraightUp_10: 'StraightUp_10',
  SixLine_13_14_15_16_17_18: 'SixLine_13_14_15_16_17_18',
  Split_10_13: 'Split_10_13',
  Street_13_14_15: 'Street_13_14_15',
  StraightUp_13: 'StraightUp_13',
  SixLine_16_17_18_19_20_21: 'SixLine_16_17_18_19_20_21',
  Split_13_16: 'Split_13_16',
  Street_16_17_18: 'Street_16_17_18',
  StraightUp_16: 'StraightUp_16',
  SixLine_19_20_21_22_23_24: 'SixLine_19_20_21_22_23_24',
  Split_16_19: 'Split_16_19',
  Street_19_20_21: 'Street_19_20_21',
  StraightUp_19: 'StraightUp_19',
  SixLine_22_23_24_25_26_27: 'SixLine_22_23_24_25_26_27',
  Split_19_22: 'Split_19_22',
  Street_22_23_24: 'Street_22_23_24',
  StraightUp_22: 'StraightUp_22',
  SixLine_25_26_27_28_29_30: 'SixLine_25_26_27_28_29_30',
  Split_22_25: 'Split_22_25',
  Street_25_26_27: 'Street_25_26_27',
  StraightUp_25: 'StraightUp_25',
  SixLine_28_29_30_31_32_33: 'SixLine_28_29_30_31_32_33',
  Split_25_28: 'Split_25_28',
  Street_28_29_30: 'Street_28_29_30',
  StraightUp_28: 'StraightUp_28',
  SixLine_31_32_33_34_35_36: 'SixLine_31_32_33_34_35_36',
  Split_28_31: 'Split_28_31',
  Street_31_32_33: 'Street_31_32_33',
  StraightUp_31: 'StraightUp_31',
  Split_31_34: 'Split_31_34',
  Street_34_35_36: 'Street_34_35_36',
  StraightUp_34: 'StraightUp_34',
  Red_Snake: 'Red_Snake',
  Black_Snake: 'Black_Snake',
  Red_Pairs: 'Red_Pairs',
  Black_Pairs: 'Black_Pairs',
  Tiers: 'Tiers',
  Orphelins: 'Orphelins',
  Voisins: 'Voisins',
  Zero: 'Zero',
};

export const RECTANGLE_TABLE_DATA = [
  {
    color: 'red',
    number: 3,
    right: BetType.Corner_2_3_5_6,
    left: BetType.Split_0_3,
    center: BetType.Split_2_3,
    self: BetType.StraightUp_3,
  },

  {
    color: '',
    number: 6,
    right: BetType.Corner_5_6_8_9,
    left: BetType.Split_3_6,
    center: BetType.Split_5_6,
    self: BetType.StraightUp_6,
  },

  {
    color: 'red',
    number: 9,
    right: BetType.Corner_8_9_11_12,
    left: BetType.Split_6_9,
    center: BetType.Split_8_9,
    self: BetType.StraightUp_9,
  },
  {
    color: 'red',
    number: 12,
    right: BetType.Corner_11_12_14_15,
    left: BetType.Split_9_12,
    center: BetType.Split_11_12,
    self: BetType.StraightUp_12,
  },
  {
    color: '',
    number: 15,
    right: BetType.Corner_14_15_17_18,
    left: BetType.Split_12_15,
    center: BetType.Split_14_15,
    self: BetType.StraightUp_15,
  },
  {
    color: 'red',
    number: 18,
    right: BetType.Corner_17_18_20_21,
    left: BetType.Split_15_18,
    center: BetType.Split_17_18,
    self: BetType.StraightUp_18,
  },
  {
    color: 'red',
    number: 21,
    right: BetType.Corner_20_21_23_24,
    left: BetType.Split_18_21,
    center: BetType.Split_20_21,
    self: BetType.StraightUp_21,
  },
  {
    color: '',
    number: 24,
    right: BetType.Corner_23_24_26_27,
    left: BetType.Split_21_24,
    center: BetType.Split_23_24,
    self: BetType.StraightUp_24,
  },
  {
    color: 'red',
    number: 27,
    right: BetType.Corner_26_27_29_30,
    left: BetType.Split_24_27,
    center: BetType.Split_26_27,
    self: BetType.StraightUp_27,
  },
  {
    color: 'red',
    number: 30,
    right: BetType.Corner_29_30_32_33,
    left: BetType.Split_27_30,
    center: BetType.Split_29_30,
    self: BetType.StraightUp_30,
  },
  {
    color: '',
    number: 33,
    right: BetType.Corner_32_33_35_36,
    left: BetType.Split_30_33,
    center: BetType.Split_32_33,
    self: BetType.StraightUp_33,
  },
  {
    color: 'red',
    number: 36,
    right: '',
    left: BetType.Split_33_36,
    center: BetType.Split_35_36,
    self: BetType.StraightUp_36,
  },
  {
    color: '',
    number: 2,
    right: BetType.Corner_1_2_4_5,
    left: BetType.Split_0_2,
    center: BetType.Split_1_2,
    self: BetType.StraightUp_2,
  },
  {
    color: 'red',
    number: 5,
    right: BetType.Corner_4_5_7_8,
    left: BetType.Split_2_5,
    center: BetType.Split_4_5,
    self: BetType.StraightUp_5,
  },
  {
    color: '',
    number: 8,
    right: BetType.Corner_7_8_10_11,
    left: BetType.Split_5_8,
    center: BetType.Split_7_8,
    self: BetType.StraightUp_8,
  },
  {
    color: '',
    number: 11,
    right: BetType.Corner_10_11_13_14,
    left: BetType.Split_8_11,
    center: BetType.Split_10_11,
    self: BetType.StraightUp_11,
  },
  {
    color: 'red',
    number: 14,
    right: BetType.Corner_13_14_16_17,
    left: BetType.Split_11_14,
    center: BetType.Split_13_14,
    self: BetType.StraightUp_14,
  },
  {
    color: '',
    number: 17,
    right: BetType.Corner_16_17_19_20,
    left: BetType.Split_14_17,
    center: BetType.Split_16_17,
    self: BetType.StraightUp_17,
  },
  {
    color: '',
    number: 20,
    right: BetType.Corner_19_20_22_23,
    left: BetType.Split_17_20,
    center: BetType.Split_19_20,
    self: BetType.StraightUp_20,
  },
  {
    color: 'red',
    number: 23,
    right: BetType.Corner_22_23_25_26,
    left: BetType.Split_20_23,
    center: BetType.Split_22_23,
    self: BetType.StraightUp_23,
  },
  {
    color: '',
    number: 26,
    right: BetType.Corner_25_26_28_29,
    left: BetType.Split_23_26,
    center: BetType.Split_25_26,
    self: BetType.StraightUp_26,
  },
  {
    color: '',
    number: 29,
    right: BetType.Corner_28_29_31_32,
    left: BetType.Split_26_29,
    center: BetType.Split_28_29,
    self: BetType.StraightUp_29,
  },
  {
    color: 'red',
    number: 32,
    right: BetType.Corner_31_32_34_35,
    left: BetType.Split_29_32,
    center: BetType.Split_31_32,
    self: BetType.StraightUp_32,
  },
  {
    color: '',
    number: 35,
    right: '',
    left: BetType.Split_32_35,
    center: BetType.Split_34_35,
    self: BetType.StraightUp_35,
  },
  {
    color: 'red',
    number: 1,
    right: BetType.SixLine_1_2_3_4_5_6,
    left: BetType.Split_0_1,
    center: BetType.Street_1_2_3,
    self: BetType.StraightUp_1,
  },
  {
    color: '',
    number: 4,
    right: BetType.SixLine_4_5_6_7_8_9,
    left: BetType.Split_1_4,
    center: BetType.Street_4_5_6,
    self: BetType.StraightUp_4,
  },
  {
    color: 'red',
    number: 7,
    right: BetType.SixLine_7_8_9_10_11_12,
    left: BetType.Split_4_7,
    center: BetType.Street_7_8_9,
    self: BetType.StraightUp_7,
  },
  {
    color: '',
    number: 10,
    right: BetType.SixLine_10_11_12_13_14_15,
    left: BetType.Split_7_10,
    center: BetType.Street_10_11_12,
    self: BetType.StraightUp_10,
  },
  {
    color: '',
    number: 13,
    right: BetType.SixLine_13_14_15_16_17_18,
    left: BetType.Split_10_13,
    center: BetType.Street_13_14_15,
    self: BetType.StraightUp_13,
  },
  {
    color: 'red',
    number: 16,
    right: BetType.SixLine_16_17_18_19_20_21,
    left: BetType.Split_13_16,
    center: BetType.Street_16_17_18,
    self: BetType.StraightUp_16,
  },
  {
    color: 'red',
    number: 19,
    right: BetType.SixLine_19_20_21_22_23_24,
    left: BetType.Split_16_19,
    center: BetType.Street_19_20_21,
    self: BetType.StraightUp_19,
  },
  {
    color: '',
    number: 22,
    right: BetType.SixLine_22_23_24_25_26_27,
    left: BetType.Split_19_22,
    center: BetType.Street_22_23_24,
    self: BetType.StraightUp_22,
  },
  {
    color: 'red',
    number: 25,
    right: BetType.SixLine_25_26_27_28_29_30,
    left: BetType.Split_22_25,
    center: BetType.Street_25_26_27,
    self: BetType.StraightUp_25,
  },
  {
    color: '',
    number: 28,
    right: BetType.SixLine_28_29_30_31_32_33,
    left: BetType.Split_25_28,
    center: BetType.Street_28_29_30,
    self: BetType.StraightUp_28,
  },
  {
    color: '',
    number: 31,
    right: BetType.SixLine_31_32_33_34_35_36,
    left: BetType.Split_28_31,
    center: BetType.Street_31_32_33,
    self: BetType.StraightUp_31,
  },
  {
    color: 'red',
    number: 34,
    right: '',
    left: BetType.Split_31_34,
    center: BetType.Street_34_35_36,
    self: BetType.StraightUp_34,
  },
];

export const OVAL_BET_DATA_MODEL = [
  {
    type: 'Tiers',
    winNumbers: [5, 8, 10, 11, 13, 16, 23, 24, 27, 30, 33, 36],
    totalChipCount: 6,
    betModels: [
      {
        type: 'Split_5_8',
        winNumbers: [5, 8],
      },
      {
        type: 'Split_10_11',
        winNumbers: [10, 11],
      },
      {
        type: 'Split_13_16',
        winNumbers: [13, 16],
      },
      {
        type: 'Split_23_24',
        winNumbers: [23, 24],
      },
      {
        type: 'Split_27_30',
        winNumbers: [27, 30],
      },
      {
        type: 'Split_33_36',
        winNumbers: [33, 36],
      },
    ],
  },
  {
    type: 'Orphelins',
    winNumbers: [1, 6, 9, 14, 17, 20, 31, 34],
    totalChipCount: 5,
    betModels: [
      {
        type: 'StraightUp_1',
        winNumbers: [1],
      },
      {
        type: 'Split_6_9',
        winNumbers: [6, 9],
      },
      {
        type: 'Split_14_17',
        winNumbers: [14, 17],
      },
      {
        type: 'Split_17_20',
        winNumbers: [17, 20],
      },
      {
        type: 'Split_31_34',
        winNumbers: [31, 34],
      },
    ],
  },
  {
    type: 'Voisins',
    winNumbers: [4, 7, 12, 15, 18, 21, 19, 22, 32, 35, 25, 26, 28, 29, 0, 2, 3],
    totalChipCount: 9,
    betModels: [
      {
        type: 'Split_4_7',
        winNumbers: [4, 7],
      },
      {
        type: 'Split_12_15',
        winNumbers: [12, 15],
      },
      {
        type: 'Split_18_21',
        winNumbers: [18, 21],
      },
      {
        type: 'Split_19_22',
        winNumbers: [19, 22],
      },
      {
        type: 'Split_32_35',
        winNumbers: [32, 35],
      },
      {
        type: 'Corner_25_26_28_29',
        winNumbers: [25, 26, 28, 29],
        chipValue: 2,
      },
      {
        type: 'Street_0_2_3',
        winNumbers: [0, 2, 3],
        chipValue: 2,
      },
    ],
  },
  {
    type: 'Zero',
    winNumbers: [0, 3, 12, 15, 32, 35, 26],
    totalChipCount: 4,
    betModels: [
      {
        type: 'Split_0_3',
        winNumbers: [0, 3],
      },
      {
        type: 'Split_12_15',
        winNumbers: [12, 15],
      },
      {
        type: 'Split_32_35',
        winNumbers: [32, 35],
      },
      {
        type: 'StraightUp_26',
        winNumbers: [26],
      },
    ],
  },
];

export const BetTypeRectangleTableBottom = {
  Dozen_1: 'Dozen_1',
  Dozen_2: 'Dozen_2',
  Dozen_3: 'Dozen_3',
  Numbers_1_18: 'Numbers_1_18',
  Even: 'Even',
  Red: 'Red',
  Black: 'Black',
  Odd: 'Odd',
  Numbers_19_36: 'Numbers_19_36',
};

export const BetTypeTableLeftColumns = {
  Column_3: 'Column_3',
  Column_2: 'Column_2',
  Column_1: 'Column_1',
};

export const REC_BET_DATA_MODEL = [
  {
    type: 'StraightUp_0',
    winNumbers: [0],
  },
  {
    type: 'StraightUp_1',
    winNumbers: [1],
  },
  {
    type: 'StraightUp_2',
    winNumbers: [2],
  },
  {
    type: 'StraightUp_3',
    winNumbers: [3],
  },
  {
    type: 'StraightUp_4',
    winNumbers: [4],
  },
  {
    type: 'StraightUp_5',
    winNumbers: [5],
  },
  {
    type: 'StraightUp_6',
    winNumbers: [6],
  },
  {
    type: 'StraightUp_7',
    winNumbers: [7],
  },
  {
    type: 'StraightUp_8',
    winNumbers: [8],
  },
  {
    type: 'StraightUp_9',
    winNumbers: [9],
  },
  {
    type: 'StraightUp_10',
    winNumbers: [10],
  },
  {
    type: 'StraightUp_11',
    winNumbers: [11],
  },
  {
    type: 'StraightUp_12',
    winNumbers: [12],
  },
  {
    type: 'StraightUp_13',
    winNumbers: [13],
  },
  {
    type: 'StraightUp_14',
    winNumbers: [14],
  },
  {
    type: 'StraightUp_15',
    winNumbers: [15],
  },
  {
    type: 'StraightUp_16',
    winNumbers: [16],
  },
  {
    type: 'StraightUp_17',
    winNumbers: [17],
  },
  {
    type: 'StraightUp_18',
    winNumbers: [18],
  },
  {
    type: 'StraightUp_19',
    winNumbers: [19],
  },
  {
    type: 'StraightUp_20',
    winNumbers: [20],
  },
  {
    type: 'StraightUp_21',
    winNumbers: [21],
  },
  {
    type: 'StraightUp_22',
    winNumbers: [22],
  },
  {
    type: 'StraightUp_23',
    winNumbers: [23],
  },
  {
    type: 'StraightUp_24',
    winNumbers: [24],
  },
  {
    type: 'StraightUp_25',
    winNumbers: [25],
  },
  {
    type: 'StraightUp_26',
    winNumbers: [26],
  },
  {
    type: 'StraightUp_27',
    winNumbers: [27],
  },
  {
    type: 'StraightUp_28',
    winNumbers: [28],
  },
  {
    type: 'StraightUp_29',
    winNumbers: [29],
  },
  {
    type: 'StraightUp_30',
    winNumbers: [30],
  },
  {
    type: 'StraightUp_31',
    winNumbers: [31],
  },
  {
    type: 'StraightUp_32',
    winNumbers: [32],
  },
  {
    type: 'StraightUp_33',
    winNumbers: [33],
  },
  {
    type: 'StraightUp_34',
    winNumbers: [34],
  },
  {
    type: 'StraightUp_35',
    winNumbers: [35],
  },
  {
    type: 'StraightUp_36',
    winNumbers: [36],
  },
  {
    type: 'Split_0_1',
    winNumbers: [0, 1],
  },
  {
    type: 'Split_0_2',
    winNumbers: [0, 2],
  },
  {
    type: 'Split_0_3',
    winNumbers: [0, 3],
  },
  {
    type: 'Split_1_2',
    winNumbers: [1, 2],
  },
  {
    type: 'Split_2_3',
    winNumbers: [2, 3],
  },
  {
    type: 'Split_4_5',
    winNumbers: [4, 5],
  },
  {
    type: 'Split_5_6',
    winNumbers: [5, 6],
  },
  {
    type: 'Split_7_8',
    winNumbers: [7, 8],
  },
  {
    type: 'Split_8_9',
    winNumbers: [8, 9],
  },
  {
    type: 'Split_10_11',
    winNumbers: [10, 11],
  },
  {
    type: 'Split_11_12',
    winNumbers: [11, 12],
  },
  {
    type: 'Split_13_14',
    winNumbers: [13, 14],
  },
  {
    type: 'Split_14_15',
    winNumbers: [14, 15],
  },
  {
    type: 'Split_16_17',
    winNumbers: [16, 17],
  },
  {
    type: 'Split_17_18',
    winNumbers: [17, 18],
  },
  {
    type: 'Split_19_20',
    winNumbers: [19, 20],
  },
  {
    type: 'Split_20_21',
    winNumbers: [20, 21],
  },
  {
    type: 'Split_22_23',
    winNumbers: [22, 23],
  },
  {
    type: 'Split_23_24',
    winNumbers: [23, 24],
  },
  {
    type: 'Split_25_26',
    winNumbers: [25, 26],
  },
  {
    type: 'Split_26_27',
    winNumbers: [26, 27],
  },
  {
    type: 'Split_28_29',
    winNumbers: [28, 29],
  },
  {
    type: 'Split_29_30',
    winNumbers: [29, 30],
  },
  {
    type: 'Split_31_32',
    winNumbers: [31, 32],
  },
  {
    type: 'Split_32_33',
    winNumbers: [32, 33],
  },
  {
    type: 'Split_34_35',
    winNumbers: [34, 35],
  },
  {
    type: 'Split_35_36',
    winNumbers: [35, 36],
  },
  {
    type: 'Split_1_4',
    winNumbers: [1, 4],
  },
  {
    type: 'Split_4_7',
    winNumbers: [4, 7],
  },
  {
    type: 'Split_7_10',
    winNumbers: [7, 10],
  },
  {
    type: 'Split_10_13',
    winNumbers: [10, 13],
  },
  {
    type: 'Split_13_16',
    winNumbers: [13, 16],
  },
  {
    type: 'Split_16_19',
    winNumbers: [16, 19],
  },
  {
    type: 'Split_19_22',
    winNumbers: [19, 22],
  },
  {
    type: 'Split_22_25',
    winNumbers: [22, 25],
  },
  {
    type: 'Split_25_28',
    winNumbers: [25, 28],
  },
  {
    type: 'Split_28_31',
    winNumbers: [28, 31],
  },
  {
    type: 'Split_31_34',
    winNumbers: [31, 34],
  },
  {
    type: 'Split_2_5',
    winNumbers: [2, 5],
  },
  {
    type: 'Split_5_8',
    winNumbers: [5, 8],
  },
  {
    type: 'Split_8_11',
    winNumbers: [8, 11],
  },
  {
    type: 'Split_11_14',
    winNumbers: [11, 14],
  },
  {
    type: 'Split_14_17',
    winNumbers: [14, 17],
  },
  {
    type: 'Split_17_20',
    winNumbers: [17, 20],
  },
  {
    type: 'Split_20_23',
    winNumbers: [20, 23],
  },
  {
    type: 'Split_23_26',
    winNumbers: [23, 26],
  },
  {
    type: 'Split_26_29',
    winNumbers: [26, 29],
  },
  {
    type: 'Split_29_32',
    winNumbers: [29, 32],
  },
  {
    type: 'Split_32_35',
    winNumbers: [32, 35],
  },
  {
    type: 'Split_3_6',
    winNumbers: [3, 6],
  },
  {
    type: 'Split_6_9',
    winNumbers: [6, 9],
  },
  {
    type: 'Split_9_12',
    winNumbers: [9, 12],
  },
  {
    type: 'Split_12_15',
    winNumbers: [12, 15],
  },
  {
    type: 'Split_15_18',
    winNumbers: [15, 18],
  },
  {
    type: 'Split_18_21',
    winNumbers: [18, 21],
  },
  {
    type: 'Split_21_24',
    winNumbers: [21, 24],
  },
  {
    type: 'Split_24_27',
    winNumbers: [24, 27],
  },
  {
    type: 'Split_27_30',
    winNumbers: [27, 30],
  },
  {
    type: 'Split_30_33',
    winNumbers: [30, 33],
  },
  {
    type: 'Split_33_36',
    winNumbers: [33, 36],
  },
  {
    type: 'Street_0_1_2',
    winNumbers: [0, 1, 2],
  },
  {
    type: 'Street_0_2_3',
    winNumbers: [0, 2, 3],
  },
  {
    type: 'Street_1_2_3',
    winNumbers: [1, 2, 3],
  },
  {
    type: 'Street_4_5_6',
    winNumbers: [4, 5, 6],
  },
  {
    type: 'Street_7_8_9',
    winNumbers: [7, 8, 9],
  },
  {
    type: 'Street_10_11_12',
    winNumbers: [10, 11, 12],
  },
  {
    type: 'Street_13_14_15',
    winNumbers: [13, 14, 15],
  },
  {
    type: 'Street_16_17_18',
    winNumbers: [16, 17, 18],
  },
  {
    type: 'Street_19_20_21',
    winNumbers: [19, 20, 21],
  },
  {
    type: 'Street_22_23_24',
    winNumbers: [22, 23, 24],
  },
  {
    type: 'Street_25_26_27',
    winNumbers: [25, 26, 27],
  },
  {
    type: 'Street_28_29_30',
    winNumbers: [28, 29, 30],
  },
  {
    type: 'Street_31_32_33',
    winNumbers: [31, 32, 33],
  },
  {
    type: 'Street_34_35_36',
    winNumbers: [34, 35, 36],
  },
  {
    type: 'Corner_0_1_2_3',
    winNumbers: [0, 1, 2, 3],
  },
  {
    type: 'Corner_1_2_4_5',
    winNumbers: [1, 2, 4, 5],
  },
  {
    type: 'Corner_2_3_5_6',
    winNumbers: [2, 3, 5, 6],
  },
  {
    type: 'Corner_4_5_7_8',
    winNumbers: [4, 5, 7, 8],
  },
  {
    type: 'Corner_5_6_8_9',
    winNumbers: [5, 6, 8, 9],
  },
  {
    type: 'Corner_7_8_10_11',
    winNumbers: [7, 8, 10, 11],
  },
  {
    type: 'Corner_8_9_11_12',
    winNumbers: [8, 9, 11, 12],
  },
  {
    type: 'Corner_10_11_13_14',
    winNumbers: [10, 11, 13, 14],
  },
  {
    type: 'Corner_11_12_14_15',
    winNumbers: [11, 12, 14, 15],
  },
  {
    type: 'Corner_13_14_16_17',
    winNumbers: [13, 14, 16, 17],
  },
  {
    type: 'Corner_14_15_17_18',
    winNumbers: [14, 15, 17, 18],
  },
  {
    type: 'Corner_16_17_19_20',
    winNumbers: [16, 17, 19, 20],
  },
  {
    type: 'Corner_17_18_20_21',
    winNumbers: [17, 18, 20, 21],
  },
  {
    type: 'Corner_19_20_22_23',
    winNumbers: [19, 20, 22, 23],
  },
  {
    type: 'Corner_20_21_23_24',
    winNumbers: [20, 21, 23, 24],
  },
  {
    type: 'Corner_22_23_25_26',
    winNumbers: [22, 23, 25, 26],
  },
  {
    type: 'Corner_23_24_26_27',
    winNumbers: [23, 24, 26, 27],
  },
  {
    type: 'Corner_25_26_28_29',
    winNumbers: [25, 26, 28, 29],
  },
  {
    type: 'Corner_26_27_29_30',
    winNumbers: [26, 27, 29, 30],
  },
  {
    type: 'Corner_28_29_31_32',
    winNumbers: [28, 29, 31, 32],
  },
  {
    type: 'Corner_29_30_32_33',
    winNumbers: [29, 30, 32, 33],
  },
  {
    type: 'Corner_31_32_34_35',
    winNumbers: [31, 32, 34, 35],
  },
  {
    type: 'Corner_32_33_35_36',
    winNumbers: [32, 33, 35, 36],
  },
  {
    type: 'SixLine_1_2_3_4_5_6',
    winNumbers: [1, 2, 3, 4, 5, 6],
  },
  {
    type: 'SixLine_4_5_6_7_8_9',
    winNumbers: [4, 5, 6, 7, 8, 9],
  },
  {
    type: 'SixLine_7_8_9_10_11_12',
    winNumbers: [7, 8, 9, 10, 11, 12],
  },
  {
    type: 'SixLine_10_11_12_13_14_15',
    winNumbers: [10, 11, 12, 13, 14, 15],
  },
  {
    type: 'SixLine_13_14_15_16_17_18',
    winNumbers: [13, 14, 15, 16, 17, 18],
  },
  {
    type: 'SixLine_16_17_18_19_20_21',
    winNumbers: [16, 17, 18, 19, 20, 21],
  },
  {
    type: 'SixLine_19_20_21_22_23_24',
    winNumbers: [19, 20, 21, 22, 23, 24],
  },
  {
    type: 'SixLine_22_23_24_25_26_27',
    winNumbers: [22, 23, 24, 25, 26, 27],
  },
  {
    type: 'SixLine_25_26_27_28_29_30',
    winNumbers: [25, 26, 27, 28, 29, 30],
  },
  {
    type: 'SixLine_28_29_30_31_32_33',
    winNumbers: [28, 29, 30, 31, 32, 33],
  },
  {
    type: 'SixLine_31_32_33_34_35_36',
    winNumbers: [31, 32, 33, 34, 35, 36],
  },
  {
    type: 'Column_1',
    winNumbers: [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34],
  },
  {
    type: 'Column_2',
    winNumbers: [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
  },
  {
    type: 'Column_3',
    winNumbers: [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36],
  },
  {
    type: 'Dozen_1',
    winNumbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  },
  {
    type: 'Dozen_2',
    winNumbers: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
  },
  {
    type: 'Dozen_3',
    winNumbers: [25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
  },
  {
    type: 'Red',
    winNumbers: [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36],
  },
  {
    type: 'Black',
    winNumbers: [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35],
  },
  {
    type: 'Even',
    winNumbers: [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36],
  },
  {
    type: 'Odd',
    winNumbers: [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35],
  },
  {
    type: 'Numbers_1_18',
    winNumbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
  },
  {
    type: 'Numbers_19_36',
    winNumbers: [19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
  },
  {
    type: 'Red_Snake',
    winNumbers: [1, 5, 9, 12, 14, 16, 19, 23, 27, 30, 32, 34],
  },
  {
    type: 'Black_Snake',
    winNumbers: [2, 6, 8, 10, 13, 24, 26, 28, 31, 35, 17, 20],
  },
  {
    type: 'Red_Pairs',
    winNumbers: [9, 12, 16, 19, 18, 21, 27, 30],
  },
  {
    type: 'Black_Pairs',
    winNumbers: [8, 10, 11, 13, 17, 20, 26, 28, 29, 31],
  },
];

export const REC_BET_DATA_MODEL_MAP = [...REC_BET_DATA_MODEL, ...OVAL_BET_DATA_MODEL].reduce(
  (item, curr) => {
    item[curr.type] = curr;
    return item;
  },
  {}
);

export const ROUlETTE_NUMBERS_BY_INDEX = {
  0: {
    index: 0,
  },
  32: {
    index: 1,
  },
  15: {
    index: 2,
  },
  19: {
    index: 3,
  },
  4: {
    index: 4,
  },
  21: {
    index: 5,
  },
  2: {
    index: 6,
  },
  25: {
    index: 7,
  },
  17: {
    index: 8,
  },
  34: {
    index: 9,
  },
  6: {
    index: 10,
  },
  27: {
    index: 11,
  },
  13: {
    index: 12,
  },
  36: {
    index: 13,
  },
  11: {
    index: 14,
  },
  30: {
    index: 15,
  },
  8: {
    index: 16,
  },
  23: {
    index: 17,
  },
  10: {
    index: 18,
  },
  5: {
    index: 19,
  },
  24: {
    index: 20,
  },
  16: {
    index: 21,
  },
  33: {
    index: 22,
  },
  1: {
    index: 23,
  },
  20: {
    index: 24,
  },
  14: {
    index: 25,
  },
  31: {
    index: 26,
  },
  9: {
    index: 27,
  },
  22: {
    index: 28,
  },
  18: {
    index: 29,
  },
  29: {
    index: 30,
  },
  7: {
    index: 31,
  },
  28: {
    index: 32,
  },
  12: {
    index: 33,
  },
  35: {
    index: 34,
  },
  3: {
    index: 35,
  },
  26: {
    index: 36,
  },
};

export const NUMBER_COLORS = RECTANGLE_TABLE_DATA.reduce((acc, current) => {
  acc[current.number] = current.color;
  return acc;
}, {});

export const ROULETTE_RULES_KEYS = new Array(isPG() ? 29 : 10)
  .fill(null)
  .map((item, index) => index + 1);
export const ROULETTE_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
